export const language: any = {
  main: "หลัก",
  ingredients: "ส่วนผสม",
  ai_chef: "AI",
  favorites: "รายการโปรด",
  menu: "เมนู",
  get_start: "เริ่มต้น",
  title_first_1: "AI แนะนำสูตรอาหารตามอายุ",
  title_second_1: "จัดระเบียบอย่างสมบูรณ์จากเมนูถึงสูตรอาหาร",
  content_1: "หยุดกังวลเกี่ยวกับเมนูและแคลอรี่ประจำวัน ตั้งแต่นี้ไป รับคำแนะนำจาก Hey! Cooker",
  title_first_2: "วันนี้อากาศเย็น คุณทำงานอย่างหนัก",
  title_second_2: "ทานสตูว์เกาหลีหลังเลิกงานเป็นไง?",
  content_2: "ค้นหาเนื้อกระป๋องและบะหมี่สำเร็จรูปที่เหลือในตู้เย็นแล้วทำอาหารเย็นแบบง่ายๆ!",
  my_food_ingredients: "ไม่รู้จะทำอะไรดี? ",
  btn_add_photo: "เลือกภาพหรือถ่ายภาพ",
  my_food_reason: "เลือกวัตถุดิบที่คุณมี",
  btn_get_cooking: "รับคำแนะนำสูตรอาหาร AI",
  enriching_title: "เติมเต็มร่างกายและจิตใจของคุณ",
  enriching: "คอลเลคชันสูตรอาหาร",
  photo_registration_title: "ถ่ายรูปหรือใบเสร็จเพื่อ<br/>รับคำแนะนำเมนู!",
  photo_registration_content: `ใช้ AI เพื่อระบุส่วนผสมและ<br/>วิเคราะห์สูตรอาหารเพื่อเพิ่มความสนุกในการทำอาหาร!`,  
  food_suggestions_title: "กังวลว่าจะกินอะไรดี?",
  food_suggestions_sub_title: "อาหารตามธีม",
  our_interests_title: "สร้างเมนูที่เหมาะกับคุณและครอบครัว!",
  our_interests_sub_title: "เลือกตามอายุและเพศของคุณ",
  favorite_title: "สมุดบันทึกการทำอาหารที่หลากหลาย",
  weather_title: "อาหารที่เหมาะกับอากาศเย็น",
  video_title: "ดูวิดีโอที่มีชีวิตชีวา",
  tag: {
    close: "ปิด",
    open: "ขยาย"
  },
  no_data: "ไม่มีข้อมูล",
  update_version_submit: "อัปเดตทันที",
  update_version_title: "เรามีเวอร์ชันล่าสุดของแอป",
  update_version_content: "เพื่อประสบการณ์การใช้งานที่ดีที่สุด โปรดอัปเดตแอปเป็นเวอร์ชันล่าสุด",
  close_btn: "ปิด",
  not_video_id: "วิดีโอไม่พบ",
  favorite_login: "เข้าสู่ระบบหรือสมัครสมาชิกเพื่อบันทึกรายการสูตรโปรดของคุณ",
  favorite_section_title: "อย่าลืมตรวจสอบสูตรที่บันทึกไว้",
  favorite_section_description: "สูตรโปรดของฉัน",
  discover: "ค้นพบ",
  my_cooker: "ครัวของฉัน",
  view_recipe: "ดูสูตรจากวัตถุดิบที่เลือก",
  my_ingredient: "วัตถุดิบของฉัน",
  add_ingredient: "เพิ่มวัตถุดิบของฉัน",
  video_section_title: "ค้นหาและสัมผัสผ่านวิดีโอ",
  video_section_description: "วิดีโออาหารแนะนำ",
  age_10: "อายุต่ำกว่า 10 ปี",
  age_10_to_20: "10-20 ปี",
  age_20_to_30: "20-30 ปี",
  age_30_to_40: "30-40 ปี",
  age_40_to_50: "40-50 ปี",
  age_more_50: "50 ปีขึ้นไป",
  suggest_section_title: "เฮ้! Cooker จะช่วยคุณเลือก",
  suggest_section_description: "หัวข้อที่คุณสนใจคืออะไร?",
  weather_title1: "คำแนะนำสำหรับวันนี้",
  weather_title2: "วันฝนตกอากาศเย็น กินอะไรดี?",
  tasteSuggestion1: "ตอบโจทย์รสชาติของคุณ",
  tasteSuggestion2: "รสชาติที่ออกแบบมาเพื่อคุณ",
  tasteTitle1: "เผ็ดร้อน <br />และยั่วยวน",
  tasteDescription1: "#ผัด #ย่าง #วันฝนตก",
  tasteTitle2: "สดชื่นและ <br />เบาสบาย",
  tasteTitle3: "เปรี้ยว <br />และเร้าใจ",
  tasteTitle4: "หอมหวาน <br />นุ่มนวล",
  tasteTitle5: "ผสมผสานและ <br />น่าดึงดูด",
  tasteDescription2: "#สดใหม่ #ไฟเบอร์ #ควบคุมน้ำหนัก",
  tasteDescription3: "#เปรี้ยว #หวาน #น่าตื่นเต้น",
  tasteDescription4: "#พิเศษ #เมล็ด #มหัศจรรย์",
  tasteDescription5: "#รสชาติ #สารอาหาร #ความรู้สึก",
  suggest_item_title1: "อาหารง่ายๆ",
  suggest_item_description1: `อาหารเช้าและกลางวันง่ายๆ<br/>สูตรอาหาร`,
  suggest_item_title2: "อาหารลดน้ำหนัก",
  suggest_item_description2: `คาร์โบไฮเดรตต่ำ<br/>อร่อยมาก`,
  suggest_item_title3: "อาหารสิ้นปี",
  suggest_item_description3: `อาหารปาร์ตี้ที่บ้าน`,
  suggest_item_title4: "อาหารเพื่อสุขภาพ",
  suggest_item_description4: `เพื่อสร้างร่างกายและจิตใจที่แข็งแรง<br/>ทางเลือกที่ดี`,
  suggest_item_title5: "ของว่างง่ายๆ",
  suggest_item_description5: `กับแกล้ม`,
  history: "ประวัติการวิเคราะห์ภาพ",
  community: {
    sub_title: "ทำอาหารกับทุกคน",
    title: "เฮ้! การค้นหาชุมชน Cooker",
    trending: "มาแรง",
    follow: "กำลังติดตาม",
    video: "วิดีโอ",
    discover: "ค้นพบ",
    no_data: "ไม่มีการอัปเดตใหม่จากชุมชน Hey! Cooker",
    discover_post: "กำลังค้นหาโพสต์เพิ่มเติมในชุมชน"
  },
  user_suggest_title1: "คำแนะนำสำหรับวันนี้",
  user_suggest_title2: "คำแนะนำสูตรอาหารแบบสุ่ม",
}


